export default __webpack_public_path__ + "static/media/bt2.952a8029.jpg";